// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1VH90","form":"styles_form__2ZBjU"};